import React, { useState } from 'react';
import GoogleCountryDropdown from './googleCountry';
import LatLanComponent from './LatLangLib';
import { GetSessionStorageData } from '../../Utilities/Helpers/Helper';
import { AUTHENTICATION } from '../../Constants/Constants';

const LocationSelector: React.FC = () => {
  const sessionCountry = GetSessionStorageData(AUTHENTICATION.SHARED.COUNTRY_NAME) || '';
  const sessionRegion = GetSessionStorageData(AUTHENTICATION.SHARED.REGION_NAME) || '';

  const [country, setCountry] = useState<string>(sessionCountry);
  const [region, setRegion] = useState<string>(sessionRegion);

  return (
    <div className='location-dropdown-wrap'>
      <GoogleCountryDropdown country={country} onChange={setCountry} />
      <LatLanComponent country={country} region={region} />
    </div>
  );
};

export default LocationSelector;